module.exports = __webpack_public_path__ + "img/fis-white.4844b6a6.svg";